module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA00lEQVR4AWOgD6iyxUT/sQEsGnhKbPIdDWdr69z2j3vW0v/3y1d8GlTSLXfIaJwTVGuw1P+49/Dfb98+Hz31asZCnBqWq2pBVLOV20BU/Hzw+N+v39g1KGVaAlUDkWWsOZD7fuOOF/0zH2SUAtX9+/ETiwbbaDOIBo4yGyD39+u350U0gejl1Hn///4lbMOHbXuf90y7F5+L3QYImqKvg8UPv3/j9LRwgfUqFS3kUPpy+vzr+SvwxQNrhU2Uj3GrmR7Qu6/nLvv35w9yPJAe04MSAAC5TA9vOkElIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/DZ.png
// module id = 1127
// module chunks = 0